/**
 * Hideable task-table columns (column show/hide).
 *
 * Single source of truth for which task-table columns the user can toggle. The
 * `id`s MUST match the `isHidden(id)` gates + hide buttons in TaskTableView. The
 * Task (name) and Actions columns are intentionally PINNED — not listed here, so
 * they can never be hidden. The shared show/hide primitives live in
 * ../shared/columnVisibility.
 */
import type { HideableColumn } from "../shared/columnVisibility";

export const TASK_HIDEABLE_COLUMNS: HideableColumn[] = [
  { id: "status", label: "Status" },
  { id: "tags", label: "Tags" },
  { id: "client", label: "Client" },
  { id: "assignee", label: "Assignee" },
  { id: "dueDate", label: "Due date" },
];
